<div class="row">
  <div class="col-4">
    <rask-input-number
      label="Nettoareal, ha"
      [(ngModel)]="skogsvardsAtgard.nettoareal"
      [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
      (change)="onNettoarealChanged($event)"
      [isNegative]="false"
      inputGroupRight="ha"
      [inputProcessor]="numberDecimalProcessor">
    </rask-input-number>
  </div>
  <div class="col-4">
    @if(this.isSadd()) {
      <rask-textmultiline
        label="Mål kg/ha"
        [value]="$safeNavigationMigration(skogsvardsAtgard?.malFrogivaHa?.toString())">
      </rask-textmultiline>
    }
    @else {
    <rask-textmultiline
      label="Mål PL/ha"
      [value]="$safeNavigationMigration(skogsvardsAtgard?.malPlantorHa?.toString())">
    </rask-textmultiline>
  }
</div>

<div class="col-4">
  <rask-textmultiline
    label="Totalt antal plantor"
    [value]="getAntalPlantor()">
  </rask-textmultiline>
</div>
</div>
@if (showTradslag()) {
  <rask-skogsvard-detaljer-for-tradslag></rask-skogsvard-detaljer-for-tradslag>
}